var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"twitter-widget",staticStyle:{"width":"400px"}},[_c('v-timeline',{attrs:{"id":_vm.twitterId,"source-type":_vm.sourceType,"options":{ 'height': _vm.twitterHeight }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }